import { nextTick, reactive, ref } from "vue";
import PhotoPlaceholder from "@images/service-photo-placeholder-mini.jpg";
import imgClient from "@js/utils/imgxClient";
import filterLogic from "@/js/vue/logic/filters";

export function useMap(filters, baseURL) {
  const mapWindow = ref(null);
  // map
  const mapWindowContent = reactive({
    title: "",
    photo: "",
    photoSrcSet: "",
    regionName: "",
    categoryName: "",
    discount_rate: 0,
    price: 0,
  });
  window.dataLayer = window.dataLayer || [];

  // detecting mobile device and portrait orientation (to position the mapWindow)

  // window.innerWidth: must return the viewport width including the size of a rendered scroll bar
  // (if any), or zero if there is no viewport (pixels).
  // window.screen.width: total width of the user's screen (pixels)

  const MAX_DEVICE_WIDTH_PX = 428;
  // max-width: width of the target display area, e.g. the browser
  // max-device-width: width of the device's entire rendering area, i.e. the actual device screen
  const query = `(max-device-width: ${MAX_DEVICE_WIDTH_PX}px) and (orientation: portrait)`;
  const mediaQuery = window.matchMedia(query);
  let isMobileAndPortraitOrientation = mediaQuery.matches;

  const mediaQueryHandler = (event) => {
    isMobileAndPortraitOrientation = event.matches;
  };

  // Prior to Safari 14, MediaQueryList is based on EventTarget, so you must use addListener()
  if (!!mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", mediaQueryHandler);
  } else {
    mediaQuery.addListener(mediaQueryHandler);
  }

  function renderMap() {
    //set map
    const mapElement = document.getElementById("mapContainer");
    const mapOptions = {
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM,
      },
      /*
       * Croatia coordinates in decimal degrees:
       *     1. Northernmost - Žabnik, Sv. Martin na Muri - 46,525556
       *     2. Southernmost -  Galijula, Palagruža  - 42,377778
       *     3. Easternmost - Ilok - 19,447222
       *     4. Westernmost - Bašanija, Cape Lako - 13,491667
       */
      restriction: {
        latLngBounds: {
          north: 46.525556,
          south: 42.377778,
          east: 19.447222,
          west: 13.491667,
        },
      },
      mapId: "94ec441e8da9b5f2",
    };

    const map = new google.maps.Map(mapElement, mapOptions);

    // find double coordinates and set bounds to display
    let locLat = [];
    let locLNg = [];
    let bounds = new google.maps.LatLngBounds();

    const { buildURL } = filterLogic(filters, baseURL);

    axios(buildURL("off"))
      .then((r) => {
        const services = r.data.data;

        services.forEach((service) => {
          // round the coordinates before checking (problem with approximately the same coordinates)
          service.lat = service.lat.toFixed(4);
          service.lon = service.lon.toFixed(4);
          /* Check coordinates */
          if (locLat.includes(service.lat)) {
            service.lat = Number(service.lat) + Math.random() / 150;
          }
          if (locLNg.includes(service.lon)) {
            service.lon = Number(service.lon) + Math.random() / 250;
          }

          locLNg.push(service.lon);
          locLat.push(service.lat);

          const setPosition = new google.maps.LatLng(service.lat, service.lon);

          /* const marker = new google.maps.Marker({
                        position: setPosition,
                        //icon: imgClient.buildURL(service.category.image),
                        path
                        map,
                    });*/

          const categoryIconURL = imgClient.buildURL(service.categoryImage);
          const marker = new CustomMarker(map, setPosition, categoryIconURL);
          marker.set("serviceId", service.id);

          bounds.extend(setPosition);

          marker.addListener("click", async () => {
            // infowindow.open(map, marker);
            hideMapWindow();
            const serviceId = marker.get("serviceId");
            const q = await axios(`/api/services/${serviceId}`);
            const service = q.data;
            mapWindowContent.serviceUrl = `/${lang}/${service.region.slug}/${service.slug}/${service.id}`;
            mapWindowContent.title = service.title;
            mapWindowContent.photo = buildPhotoURL(service.primary_photo);
            mapWindowContent.photoSrcSet = buildSrcSet(service.primary_photo);
            mapWindowContent.regionName = service.region.name;
            mapWindowContent.regionSlug = service.region.slug;
            mapWindowContent.categoryName = service.category.name;
            mapWindowContent.categorySlug = service.category.slug;
            mapWindowContent.discount_rate = service.discount_rate;
            mapWindowContent.group_num_for_min_price = service.group_num_for_min_price;
            mapWindowContent.price = service.min_price;
            mapWindowContent.priceDL = service.init_price;

            dataLayer.push({
              event: "mapDetailOpen",
              experience: service.title,
              location: service.region.slug,
              experienceType: service.category.slug,
              price: service.init_price,
            });

            // executed after the next DOM update cycle...
            // wait for DOM update to position the mapWindow (for accurate window height calculation)
            nextTick(() => {
              positionTheMapWindow(marker, map);
            });
          });
        });
        map.fitBounds(bounds);
      })
      .catch((error) => {
        console.log(error);
      });

    // events
    google.maps.event.addListener(map, "zoom_changed", function () {
      hideMapWindow();
    });
    google.maps.event.addListener(map, "dragstart", function () {
      hideMapWindow();
    });

    google.maps.event.addListenerOnce(map, "bounds_changed", function () {
      limitInitialMapZoom(map);
    });

    window.addEventListener(
      "mapViewDisplayed",
      function () {
        map.fitBounds(bounds);
        limitInitialMapZoom(map);
      },
      { once: true }
    );
  }

  function limitInitialMapZoom(map) {
    const MAX_ZOOM_LIMIT = 16;
    const mapZoom = map.getZoom() || MAX_ZOOM_LIMIT;
    const zoom = Math.min(MAX_ZOOM_LIMIT, mapZoom);
    map.setZoom(zoom);
  }

  function hideMapWindow() {
    mapWindow.value.style.display = "none";

    // ...and remove active marker
    const activeMarker = document.querySelector(".map-marker.active");
    if (activeMarker) {
      activeMarker.classList.remove("active");
    }
  }

  /**
   * Custom overlays docs:
   * https://developers.google.com/maps/documentation/javascript/customoverlays
   * overlayMouseTarget: https://stackoverflow.com/questions/3361823/make-custom-overlay-clickable-google-maps-api-v3
   */
  class CustomMarker extends google.maps.OverlayView {
    latLng;
    image;
    div;

    constructor(map, latLng, image) {
      super();
      this.latLng = latLng;
      this.image = image;
      this.setMap(map);
    }

    /**
     * onAdd is called when the map's panes are ready and the overlay has been
     * added to the map.
     */
    onAdd() {
      const self = this;

      if (!this.div) {
        this.div = document.createElement("div");
        this.div.className = "map-marker";
        this.div.style.position = "absolute";
        this.div.style.width = "45px";
        this.div.style.height = "45px";

        // Create the img element and attach it to the div.
        const img = document.createElement("img");

        img.src = this.image;
        img.alt = this.imageAlt;
        img.style.width = "100%";
        img.style.height = "100%";
        // img.style.position = 'absolute';
        this.div.appendChild(img);
      }

      // Add google "click" event for the div
      this.div.addEventListener("click", function (event) {
        google.maps.event.trigger(self, "click");
      });
      // Add the element to the "overlayLayer" pane.
      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(this.div);
    }

    draw() {
      const point = this.getProjection().fromLatLngToDivPixel(this.latLng);

      // Display div at the point...
      if (point) {
        this.div.style.left = point.x - this.div.offsetWidth / 2 + "px";
        const bottomArrowSize = 5;
        this.div.style.top = point.y - this.div.offsetHeight - bottomArrowSize + "px";
      }
    }

    /**
     * The onRemove() method will be called automatically from the API if
     * we ever set the overlay's map property to 'null'.
     */
    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        delete this.div;
      }
    }

    /**
     * Get the position of the marker (latLng)
     */
    getPosition() {
      return this.latLng;
    }

    markActive() {
      if (this.div) {
        this.div.classList.add("active");
      }
    }
  }

  // positioning the map window
  function positionTheMapWindow(marker, map) {
    marker.markActive();
    const mapElBounding = map.getDiv().getBoundingClientRect();
    const mapWindowEl = mapWindow.value;
    // display mapWindowEl element before retrieval DOMRect (getBoundingClientRect: object providing
    // information about the size and position of an element)
    mapWindowEl.style.display = "block";
    const windowWidth = mapWindowEl.offsetWidth;
    const windowHeight = mapWindowEl.offsetHeight;
    const windowPad = 10;

    if (isMobileAndPortraitOrientation) {
      // mapWindowEl.style.top = mapElBounding.height - windowHeight - windowPad + 'px'; // bottom
      mapWindowEl.style.top = windowPad + "px";
      // center horizontally
      mapWindowEl.style.left = mapElBounding.width / 2 - windowWidth / 2 + "px";
      return;
    }

    // Increasing zoom one level doubles the scale, increasing scale also means increasing
    // the map’s size in pixels, each higher zoom level results in a resolution four times higher
    // than the preceding level (x * y)
    const scale = 1 << map.getZoom(); // same as (with better performance): Math.pow(2, map.getZoom());

    // https://developers.google.com/maps/documentation/javascript/maptypes#ProjectionTransformation
    // https://developers.google.com/maps/documentation/javascript/coordinates#world-coordinates
    // Whenever the API needs to translate a location in the world to a location on a map,
    // it first translates latitude and longitude values into a world coordinate (Mercator projection).
    // World coordinates in Google Maps are measured from the Mercator projection's origin
    // (the northwest corner of the map at 180 degrees longitude and approximately 85 degrees latitude)
    // and increase in the x direction towards the east (right) and increase in the y direction towards
    // the south (down). Because the basic Mercator Google Maps tile is 256 x 256 pixels,
    // the usable world coordinate space is {0-256}, {0-256}.
    // projections
    const projection = map.getProjection();

    const topRightWorldCoordinate = projection.fromLatLngToPoint(map.getBounds().getNorthEast());
    const bottomLeftWorldCoordinate = projection.fromLatLngToPoint(map.getBounds().getSouthWest());
    const markerWorldCoordinate = projection.fromLatLngToPoint(marker.getPosition());

    // Pixel coordinates reference a specific pixel on the map at a specific zoom level, whereas world
    // coordinates reflect absolute locations on a given projection. Pixel coordinates are calculated
    // using the following formula: pixelCoordinate = worldCoordinate * scale (scale=2^zoomLevel)
    // Note that for zoom level 0, the pixel coordinates are equal to the world coordinates.

    // Calculate offset for the position of the marker - in pixels (top/left/right/bottom)
    const markerOffset = {
      top: Math.floor((markerWorldCoordinate.y - topRightWorldCoordinate.y) * scale),
      left: Math.floor((markerWorldCoordinate.x - bottomLeftWorldCoordinate.x) * scale),
      right: Math.floor((topRightWorldCoordinate.x - markerWorldCoordinate.x) * scale),
      bottom: Math.floor((bottomLeftWorldCoordinate.y - markerWorldCoordinate.y) * scale),
    };

    // todo marker getIcon.getSize ?
    const windowOffset = 40;

    const availableSpaces = [
      {
        px: markerOffset.top - windowHeight - windowOffset - windowPad,
        side: "top",
      },
      {
        px: markerOffset.right - windowWidth - windowOffset - windowPad,
        side: "right",
      },
      {
        px: markerOffset.bottom - windowHeight - windowOffset - windowPad,
        side: "bottom",
      },
      {
        px: markerOffset.left - windowWidth - windowOffset - windowPad,
        side: "left",
      },
    ];

    // Check if it is possible to place the map window to top, right, below or left

    // If there is enough space, prefer the top position
    // const top = availableSpaces.find((space) => space.side === 'top');
    // if (top.px > 0) {
    //     toPosition(top.side);
    //     return;
    // }

    // Display in the place where there is the most space
    const maxSpace = availableSpaces.reduce((a, b) => (a.px > b.px ? a : b));

    toPosition(maxSpace.side);

    function toPosition(side) {
      switch (side) {
        case "left": {
          // todo: dodati - marker height/2
          let top = Math.floor(markerOffset.top - windowHeight / 2);
          let left = Math.floor(markerOffset.left - windowWidth - windowOffset);
          [top, left] = adjustToMap(top, left);
          mapWindowEl.style.top = top + "px";
          mapWindowEl.style.left = left + "px";
          break;
        }
        case "right": {
          // todo dodati - marker height/2
          let top = Math.floor(markerOffset.top - windowHeight / 2);
          let left = Math.floor(markerOffset.left + windowOffset);
          [top, left] = adjustToMap(top, left);
          mapWindowEl.style.top = top + "px";
          mapWindowEl.style.left = left + "px";
          break;
        }
        case "bottom": {
          let top = Math.floor(markerOffset.top + 10);
          let left = Math.floor(markerOffset.left - windowWidth / 2);
          [top, left] = adjustToMap(top, left);
          mapWindowEl.style.top = top + "px";
          mapWindowEl.style.left = left + "px";
          break;
        }
        default:
        case "top": {
          let top = Math.floor(markerOffset.top - windowHeight - windowOffset - windowPad);
          let left = Math.floor(markerOffset.left - windowWidth / 2);
          [top, left] = adjustToMap(top, left);
          mapWindowEl.style.top = top + "px";
          mapWindowEl.style.left = left + "px";
          break;
        }
      }

      // keep the mapWindow inside the map
      function adjustToMap(top, left) {
        // left adjustment
        if (left < windowPad) {
          left = windowPad;
        }
        // right adjustment
        let spaceRight = left + windowWidth + windowPad;
        if (spaceRight > mapElBounding.width) {
          left = mapElBounding.width - windowWidth - windowPad;
        }

        // top adjustment
        if (top < windowPad) {
          top = windowPad;
        }

        // bottom adjustment
        let spaceBottom = top + windowHeight + windowPad;
        if (spaceBottom > mapElBounding.height) {
          top = mapElBounding.height - windowHeight - windowPad;
        }

        return [top, left];
      }
    }
  }

  // TO-DO: refactor, move to CardsWithMapAndFilters.vue, add anchor element and @click function for dataLayer
  function openService(serviceInfo) {
    dataLayer.push({
      event: "mapDetailClick",
      experience: serviceInfo.title,
      location: serviceInfo.regionSlug,
      experienceType: serviceInfo.categorySlug,
      price: serviceInfo.priceDL,
    });
  }

  // todo: refactor url generation
  function buildPhotoURL(photo) {
    if (!photo) return PhotoPlaceholder;
    return imgClient.buildURL(photo.photo_name, {
      w: 500,
      auto: "compress,format,enhance",
    });
  }

  function buildSrcSet(photo) {
    if (!photo) return "";

    return imgClient.buildSrcSet(
      photo.photo_name,
      {
        auto: "compress,format,enhance",
      },
      { minWidth: 350, maxWidth: 1200 }
    );
  }

  return {
    renderMap,
    mapWindow,
    hideMapWindow,
    mapWindowContent,
    openService,
  };
}
